<div
  class="modal lg-modal fade"
  id="qrCodeModal"
  tabindex="-1"
  aria-labelledby="jdsModalSizeXl"
  aria-hidden="true"
  style="display: none"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-1" id="jdsModalLabel2">
            Pending Payment Via PayNow
          </h5>
        </div>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onPaynowQRPopupClose()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
          <div style="font-weight: bold;" class="mt-0 mb-0 text-danger">Note:</div>
          <span class="text-danger" [innerHTML]="note"></span>
        </div>
        <div class="lg-modal-content d-none d-lg-flex">
          <ng-container [ngTemplateOutlet]="qrCode"></ng-container>
          <div class="d-flex flex-column">
            <ng-container [ngTemplateOutlet]="paymentDetailsRef"></ng-container>
            <ng-container [ngTemplateOutlet]="nextSteps"></ng-container>
          </div>
        </div>

        <!-- mobaile screen modal start -->
        <div class="sm-modal-content d-block d-lg-none">
          <div class="d-flex flex-column gap-4">
            <div class="payment-info-section d-flex flex-column align-items-center text-center gap-3">
              <ng-container [ngTemplateOutlet]="qrCode"></ng-container>
              <ng-container [ngTemplateOutlet]="paymentDetailsRef"></ng-container>
            </div>
            <ng-container [ngTemplateOutlet]="nextSteps"></ng-container>
          </div>
          <!-- mobaile screen modal end -->
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="d-flex align-items-center gap-2 save-qr-btn btn btn-primary font-weight-bold"
            (click)="downloadQrCode()"
            [disabled]="!allowDownloads"
          >
            Save QR Code <i class="fa-solid fa-download"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #qrCode>
    <div class="qr-code">
      <img class="qr-code-img" [src]="qrDetails?.qrCodeBase64String" alt="QR Code" />

      <div class="qr-reference-details text-center" *ngIf="qrDetails?.showUenPac">
        <div><strong>UEN:</strong> {{qrDetails?.uen}}</div>
          <strong>Reference Number:</strong> {{pacToShow}}
      </div>
    </div>
  </ng-template>

  <ng-template #paymentDetailsRef>
    <div
      class="alert alert-default has-icon alert-large rounded flex-fill"
      role="alert"
      *ngIf="qrDetails"
    >
      <div class="alert-content d-flex flex-column gap-1">
        <div class="payment-info">
          <span class="key">Payment by: </span>
          <span class="value">{{ qrDetails.qrExpiryDateTime | date: 'd MMMM y, h:mm a (zzz)' }}</span>
        </div>
        <div class="payment-info">
          <span class="key">Payment amount: </span>
          <span class="value">{{ qrDetails.amount | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #nextSteps>
    <div
      class="alert rounded alert-info d-flex flex-column gap-3 has-icon alert-large"
      role="alert"
    >
      <div class="d-flex w-100 gap-2 align-items-center">
        <i class="fa-solid fa-circle-info"></i>
        <span class="info-heading">Next steps:</span>
      </div>
      <div class="alert-content">
        <ul class="d-flex flex-column gap-2">
          <li>
            To complete the payment, scan the PayNow QR code with your banking app, or save the QR code on your device for retrieval in your banking app.
          </li>
          <li>
            The payment will only be processed once payment is received. No payment will be processed if payment is not completed in time.
          </li>
          <li *ngIf="qrDetails?.showUenPac">
            If you are not able to pay via the PayNow QR code, you can PayNow to <strong>UEN: {{qrDetails?.uen}}</strong>. Please indicate the <strong>Reference Number</strong> provided under the QR code.
            <br/>
            <strong>Note:</strong> Payment via UEN without the correct reference number provided may delay the payment processing. Such payment may not be accepted if it is processed after the due date.
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</div>

